import styled, { css } from 'styled-components'

import { Colors } from 'common-constants/colors'

export interface FontCssProps {
  // Пробросил все-таки настройки, посмотрим сколько еще таких вариаций
  // придумают дизайнеры
  fontSize?: number
  boldText?: boolean
  color?: string
}

export const FontCss = css<FontCssProps>`
  font-size: ${(props) => props.fontSize}px;

  /* IE странно наследует от ссылки значение font-weight: bold; */
  font-weight: ${(props) => (props.boldText ? 'bold' : 'normal')};
  color: ${(props) => (props.color ? props.color : Colors.black)};
`

export const PlainTitle = styled.div<FontCssProps>`
  ${FontCss}
`
